import { useEffect } from "react";
import './ClickToChat.css';


export const ClickToChat = () => {
    useEffect(() => {
        if ((window as any).Five9SocialWidget) {
          (window as any).Five9SocialWidget.addWidget({
            type: "chat",
            rootUrl: "https://app.five9.com/consoles/",
            tenant: "PlanSource",
            title: "PlanSource Chat",
            profiles: ["Consumer Chat"],
            showProfiles: false,
            useBusinessHours: true,
            showEmailButton: false,
            theme: "default-theme.css",
          });
        }
    }, []);
      
      
    return (
        <></>
    );
};